import { CONTEXT_EVENTS } from '../../constants/events'


const defaultContext = {
  togglePopup: false,
  isQCashEnabled: false,
  qCashDetails: {},
  // isFlyingCarpetAdEnabled: false,
  showLoader: false
};

/**
 * Defualt context values for jobs.Can include city,role,packs
 */
const contextReducer = (state = defaultContext, actions) => {
	switch (actions.type) {
    case CONTEXT_EVENTS.UPDATE_CONTEXT: {
      state = Object.assign({}, state, actions.payload);
      break;
    }
    case CONTEXT_EVENTS.SEARCH_POPUP_TOGGLE: {
      // use state as first parameter
      state = Object.assign(state, {'togglePopup': actions.payload.value});
      break;
    }
    case CONTEXT_EVENTS.TOGGLE_LOADER: {
      state = Object.assign({}, state, actions.payload);
      break;
    }
  }

  return state;
};

export default contextReducer;



// WEBPACK FOOTER //
// ../q-jobs/src/reducers/ContextReducer/index.js